export default __webpack_public_path__ + "static/media/2.bfbe1de0.svg";